import { Link } from 'react-router-dom';
import { useDataBoxEvents } from '@gov-nx/core/events';
import {
	useConfiguration,
	useTranslationWithNamespace,
} from '@gov-nx/core/service';
import { useDataBoxAccess } from '@gov-nx/module/data-box';
import { PageCode } from '@gov-nx/module/page';
import { Button, Icon } from '@gov-nx/ui/web';

interface DataboxManagementButtonsProps {
	connectedDataboxes: string[];
	handleShowMoreLess: () => void;
}

export const DataboxManagementButtons = ({
	connectedDataboxes,
	handleShowMoreLess,
}: DataboxManagementButtonsProps) => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tds = getLocalizeCurried(PageCode['datove-schranky']);

	const {
		possibleToConnect,
		possibleToCreate,
		listToConnectTypes,
		connectedIds,
	} = useDataBoxAccess();
	const { zalozeniDatoveSchrankyUrl } = useConfiguration();
	const { connect } = useDataBoxEvents();

	const showCreateButton = possibleToCreate && zalozeniDatoveSchrankyUrl;
	const showDisplayMoreButton = connectedIds.length > 2;

	if (!showDisplayMoreButton && !possibleToConnect && !showCreateButton) {
		return null;
	}

	return (
		<div className="flex gap-4 flex-col pt-10 border-t border-(--border-subtlest) [ md:flex-row ]">
			{showDisplayMoreButton && (
				<Button
					onClick={() => handleShowMoreLess()}
					color="primary"
					type="solid"
					aria-label={tds('schranky.ukazat-vice-datovek')}
					iconStart={
						<Icon
							type="templates"
							name={
								connectedDataboxes.length === 2
									? 'caret-down-fill'
									: 'caret-up-fill'
							}
						/>
					}>
					{connectedDataboxes.length === 2
						? tds('schranky.ukazat-vice-datovek')
						: tds('schranky.ukazat-mene-datovek')}
				</Button>
			)}
			{possibleToConnect && (
				<Button
					onClick={() => connect({ requiredTypes: listToConnectTypes })}
					color="primary"
					type="outlined"
					aria-label={tds('schranky.pripojit-dalsi-datovku')}
					iconStart={
						<Icon
							type="templates"
							name="plus-circle"
						/>
					}>
					{tds('schranky.pripojit-dalsi-datovku')}
				</Button>
			)}
			{showCreateButton && (
				<Button
					asChild
					color="primary"
					type="outlined"
					iconStart={
						<Icon
							type="templates"
							name="plus-circle"
						/>
					}
					aria-label={tds('nastaveni.zalozit-datovou-schranku-fo')}>
					<Link
						to={zalozeniDatoveSchrankyUrl}
						target="_blank">
						{tds('nastaveni.zalozit-datovou-schranku-fo')}
					</Link>
				</Button>
			)}
		</div>
	);
};
